// Copyright (c) 2025 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { useUtilityAutomationClient } from '../../../contexts/UtilityAutomationApiContext';
import { DeadTask, UtilityBackend } from '../../../utils/UtilityAutomationApiClient';

const useTasks = (
  backend: UtilityBackend,
  trigger?: string,
): UseQueryResult<DeadTask<unknown>[], string> => {
  const deadTaskClient = useUtilityAutomationClient();
  return useQuery({
    queryKey: [deadTaskClient, backend, trigger],
    queryFn: async () => {
      return deadTaskClient.deadTasks(backend, trigger!);
    },
    enabled: !!trigger,
  });
};

export default useTasks;
